// Tiny pub/sub so PlanLimitBanner (rendered once in Layout.jsx, outside
// any page's own component tree) can refresh immediately when something
// on the Devices page adds/removes an agent, instead of waiting for its
// own 60s poll. A plain window CustomEvent avoids wiring a new Context
// provider through the whole app just for this one signal.
const EVENT_NAME = "mb:device-count-changed";

export function notifyDeviceCountChanged() {
    if (typeof window === "undefined") return;
    window.dispatchEvent(new Event(EVENT_NAME));
}

export function onDeviceCountChanged(handler) {
    if (typeof window === "undefined") return () => {};
    window.addEventListener(EVENT_NAME, handler);
    return () => window.removeEventListener(EVENT_NAME, handler);
}
